import React from "react";
import {connect, ConnectedProps} from "react-redux";
import {Login, AuthGState} from "@leap4/frontend";
import {RootState} from "../../../interfaces/root-state.interface";
import {
    BACKEND_SERVICE_NAME,
    redirectUrlForAuthenticated,
    meUrl,
    meMultiUrl,
    setCookieUrl,
    loginUrl,
    requiredAuthRoles
} from "../../../config/generals";


const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}


const LoginContainer = ({auth}: IProps) => {
    return <Login {...{redirectUrlForAuthenticated,  setCookieUrl, loginUrl}}
                  user={auth.user}
                  // meUrl={meMultiUrl}
                  meUrl={meUrl}
                  serviceName={BACKEND_SERVICE_NAME}
                  dashboardName={"Auth Dashboard"}
                  requiredRoles={requiredAuthRoles}/>;
}

export default connector(LoginContainer)
